/*
 * LoadingFallback
 *
 * Renderoituu kun lazy-loadattu moduulinäkymä latautuu.
 * Pidetään yksinkertaisena: pieni teksti, ei spinneriä joka ei välttämättä ehdi näkyä.
 */
export function LoadingFallback() {
  return (
    <div
      className="flex h-32 items-center justify-center text-base text-usva-t"
      role="status"
      aria-live="polite"
    >
      <span>Ladataan...</span>
    </div>
  );
}
